var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loader'),_c('div',{staticClass:"wrapper"},[_c('HeaderStyle2'),_c('div',{staticClass:"content-page",attrs:{"id":"content-page"}},[_c('transition',{attrs:{"name":"router-anim","enter-active-class":"animated  fadeInUp","mode":"out-in","leave-active-class":"animated fadeOut"}},[_c('router-view')],1)],1)],1),_c('LayoutFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }